<template>
  <div class="dados-fisicos-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4">
          <field-section
            :label="$t('Peso')"
            :value="tag.peso"
            :is-restrict="$store.getters['tagFuncionario/isRestrict']('peso')"
          >
            <template #value>
              {{ convert(tag.peso, " Kg") }}
            </template>
          </field-section>
        </v-col>
        <v-col class="mb-4">
          <field-section
            :label="$t('Altura')"
            :value="tag.altura"
            :is-restrict="$store.getters['tagFuncionario/isRestrict']('altura')"
          >
            <template #value>
              {{ convert(tag.altura, " m") }}
            </template>
          </field-section>
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Dados_Fisicos") || "") + " | %s",
  },
  components: { FieldSection, PageSection, PageHeader, Form },
  data: () => ({
    title: i18next.t("Dados_Fisicos"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
    convert() {
      return (value, suffix) =>
        value &&
        this.$options.filters.number(Number(value), "0.00", {
          decimalSeparator: ",",
          thousandsSeparator: ".",
        }) + suffix;
    },
  },
};
</script>

<style scoped></style>
